import { Box } from '@mui/material';
import { FC, useState } from 'react';

import { observer } from 'mobx-react-lite';
import CardContainer from '../../components/cards/CardContainer';
import useMedia from '../../hooks/useMedia';
import ThemedButton from '../../components/button/ThemedButton';
import UpdatePasswordModal from '../../components/dialog/UpdatePasswordModal';

const UpdatePassword: FC = observer(() => {
  const isMobile = useMedia('md');
  const [open, setOpen] = useState(false);

  const title = 'Kennwort aktualisieren';

  const handleButtonClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box height={1} width={1} paddingLeft={2} paddingRight={1}>
      <UpdatePasswordModal open={open} onClose={handleClose} />

      <CardContainer
        title={title}
        customStyle={{
          sx: {
            height: isMobile ? 1 : 'auto',
            minHeight: isMobile ? 1 : '15vh',
            margin: 0,
          },
        }}
        iconOn
        iconName={title}
      >
        <Box sx={{ width: 200, marginBottom: 6, paddingTop: 2 }}>
          <ThemedButton label="Ändern" onClick={handleButtonClick} />
        </Box>
      </CardContainer>
    </Box>
  );
});

export default UpdatePassword;
